import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {ActionList} from '@primer/react'
import {clsx} from 'clsx'
import type {FC} from 'react'

import styles from './RowLoading.module.css'

type Props = {
  width?: string
  showCompactDensity?: boolean
}

const RowLoading: FC<Props> = ({width = 'random', showCompactDensity = false}) => (
  <ActionList.Item aria-disabled="true">
    <div className={clsx(styles.rowLoadingContainer, showCompactDensity && styles.compactDensity)}>
      <LoadingSkeleton variant="elliptical" height="md" width="md" />
      <div className={styles.rowLoadingContent}>
        <LoadingSkeleton variant="rounded" height="sm" width={width}>
          <span className="sr-only">loading</span>
        </LoadingSkeleton>
        {!showCompactDensity && (
          <LoadingSkeleton variant="rounded" height="12px" width={width} className={styles.LoadingSkeleton} />
        )}
      </div>
    </div>
  </ActionList.Item>
)

export default RowLoading
